export default function range(size: number) {
  return [...Array(size).keys()];
}
